module.exports = __webpack_public_path__ + "img/canbadge_daishi_70_90mm_trimmark.c0667ab8.png";